export default __webpack_public_path__ + "static/media/s4_female.0d60d1f2.wav";